module.exports = __webpack_public_path__ + "img/cabbage-posterized-small-alpha.d54efbfe.png";